import styled from 'styled-components';
import { Form, Input, Divider, Button, Select } from 'antd';

import { tangerineGradient, tangerineGradientRevert } from '../../styles';
import { AvatarImage } from '../avatar/styled-components';
import { DatePicker } from '../popovers';

const FormItem = Form.Item;

export const FormItemS = styled(FormItem)`
  label {
    color: ${props => props.theme.colors.fontSilverDark};
  }
  
  .ant-form-item-label {
    line-height: 2;
  }
`;

export const SelectS = styled(Select)`
  font-size: 14px;
`;

export const SelectDropdown = styled.div`
  .ant-select-dropdown-menu-item {
    padding: 10px 0 0 10px;
  }
`;

export const OptionPart = styled.div`
    max-width: 165px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const InputS = styled(Input)`
  font-size: 14px;
`;

export const DividerS = styled(Divider)`
  width: calc(100% + 48px);
  margin: 24px -24px;
`;

export const ButtonWrapper = styled.div`
  text-align: right;
`;

export const ButtonSave = styled(Button)`
  ${tangerineGradient};
  color: ${props => props.theme.colors.white};
  width: 150px;
  height: 40px;
  border: none;
  &:hover,
  &:focus {
    ${tangerineGradientRevert};
  }
`;

export const AddContactButton = styled(Button)`
  ${tangerineGradient};
  color: ${props => props.theme.colors.white};
  width: 100%;
  height: 40px;
  border: none;
  &:hover,
  &:focus {
    ${tangerineGradientRevert};
  }
`;

export const Title = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  color: ${props => props.theme.colors.fontSilverDark};
  margin-bottom: 30px;  
`;

export const Controls = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  && > * {
    display: flex;
    align-items: center;
    margin: 0 23px 0 0;
  }
`;

export const DetailItem = styled.div`
  &:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const DatePickerS = styled(DatePicker)`
  .ant-calendar-picker-clear, .ant-calendar-picker-icon {
    color: ${props =>
    props.disabled
      ? props.theme.colors.borderLightestSilver
      : props.theme.colors.tangerinePrimary};
    width: 18px;
    height: 18px;
    margin-top: -10px;
    line-height: 18px;
    font-size: 16px;
    &:after {
      color: ${props => props.theme.colors.tangerinePrimary};
      font-size: 18px;
      width: 18px;
      height: 18px;
    }
  }
`;

export const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const UserImageWrap = styled(AvatarImage)`
  margin-right: 15px;
`;

export const FieldWrapper = styled.div`
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/components/request-form/styles.js